"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
// import {
//   CustomEase
// } from "gsap/CustomEase";
import Vivus from "vivus";
import { slideDown, slideUp } from "slide-anim";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let boxes = document.querySelectorAll(".renewal-case-box-after");

ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 768px)": function () {
    boxes.forEach((box) => {
      gsap.to(box, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: box,
          start: "top center",
          end: "bottom",
          //markers: true,
        },
      });
    });
  },
  // mobile
  "(max-width: 767px)": function () {
    boxes.forEach((box) => {
      gsap.to(box, {
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: box,
          start: "top center",
          end: "bottom",
          // markers: true,
        },
      });
    });
  },
});

// アンカーリンクのスムーススクロール実装
document.querySelectorAll(".renewal-anchor-item").forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    e.preventDefault();
    const href = anchor.getAttribute("href");
    const target = document.querySelector(href);

    if (target) {
      const headerHeight = document.querySelector(".header").offsetHeight;

      gsap.to(window, {
        duration: 0.8,
        scrollTo: {
          y: target,
          offsetY: headerHeight,
          autoKill: false,
        },
        ease: "power3.out",
      });
    }
  });
});
